import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles<Theme, { bufferedProgress: number }>(() =>
  createStyles({
    progressAction: {
      position: 'absolute',
      bottom: '0',
      left: 0,
      zIndex: 1000,
      width: '100%',

      background: 'rgba(0,0,0,0.1)',
    },
    bottomActions: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 8px 4px 8px',
    },
    controlsLeftContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    },
    volumeWrapper: {
      width: 200,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    },
    volumeSliderWrapper: {
      width: 150,
    },
    controlsContainer: {},
    progressBarContainer: {
      position: 'relative',
    },
    progressBar: {
      position: 'relative',
      '&:hover': {
        '&:before': {
          content: '""',
          height: 6,

          position: 'absolute',
          left: 0,
          bottom: -2,
          zIndex: 1,
          paddingLeft: 16,
        },
      },
      '&:before': {
        content: '""',
        height: '100%',
        backgroundColor: '#ACADB1',
        position: 'absolute',
        left: 0,
        bottom: 0,
        zIndex: 1,
        paddingLeft: 16,
        width: ({ bufferedProgress }: { bufferedProgress: number }) => `calc(${bufferedProgress}% - 16px)`,
      },
      '& .MuiSlider-track ': {
        zIndex: 50,
      },
      '& .MuiSlider-thumb ': {
        zIndex: 50,
      },
    },
  }),
);
